import { useMutation, useQueryClient } from '@tanstack/react-query';
import i18next from 'i18next';
import { useServices, useStores } from 'index';
import { BillingInfoUpdate } from 'types/billing';

type Callbacks = {
  onSuccess?: () => Promise<void> | void;
};

export const useUpdateBillingAddress = (callbacks?: Callbacks) => {
  const queryClient = useQueryClient();
  const billingService = useServices().billingService;
  const notificationsStore = useStores().notificationStore;

  return useMutation({
    mutationFn: (billingInfo: BillingInfoUpdate) => billingService.updateBillingAddress(billingInfo),
    onSuccess: async () => {
      await Promise.all([queryClient.invalidateQueries({ queryKey: ['userBillingInfo'] })]);
      notificationsStore.addToast('success', i18next.t('YourBillingAddressHasBeenUpdated', { ns: 'billingInformation' }), 'success');
      await callbacks?.onSuccess?.();
    },
    onError: () => notificationsStore.addToast('error', i18next.t('UpdateBillingAddressError', { ns: 'organizationPage' }), 'error'),
  });
};
